import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IProps {
  blocked?: boolean
  description: string
  onPress: () => void
  statusLabel: string
  statusTone: 'success' | 'danger' | 'neutral'
  title: string
}

const PreferenceCard: React.FC<IProps> = ({
  blocked,
  description,
  onPress,
  statusLabel,
  statusTone,
  title
}) => {
  const statusClassName = {
    danger: 'text-status-danger-foreground',
    neutral: 'text-text-primary',
    success: 'text-status-success-foreground'
  }[statusTone]

  return (
    <button
      type='button'
      onClick={onPress}
      className={`w-full rounded-md border border-border-subtle bg-surface-card p-6 text-left transition-opacity ${blocked ? 'opacity-50' : ''}`}
      aria-disabled={blocked}
    >
      <div className='flex items-start gap-4'>
        <div className='flex-1'>
          <div className='flex items-start justify-between gap-4'>
            <p className='text-base font-bold text-text-primary'>{title}</p>

            <p className={`text-base font-bold ${statusClassName}`}>
              {statusLabel}
            </p>
          </div>

          <p className='mt-3 text-base text-text-secondary'>{description}</p>
        </div>

        <FontAwesomeIcon
          icon={['fal', 'chevron-right']}
          className='mt-1 text-icon-primary'
        />
      </div>
    </button>
  )
}

export default PreferenceCard
